import React from "react";
import { BiSearch } from "@react-icons/all-files/bi/BiSearch";
import { navigate } from "gatsby";

export default function SearchBox({
  children,
  className,
  query,
  onChange,
  searchBase = "/destinations/",
}) {
  const searchHandler = (event) => {
    event.preventDefault();
    navigate(`${searchBase}?q=${encodeURI(query)}`);
  };

  return (
    <form className={`flex space-x-4 ${className}`} onSubmit={searchHandler}>
      <input
        type="text"
        className="h-16 flex-grow w-full border-2 border-primary p-4 text-xl"
        value={query || ""}
        onChange={(event) => onChange(event.target.value)}
        aria-label="Search Text"
      ></input>

      <button
        type="submit"
        className="h-16 w-16 bg-primary flex flex-col justify-center"
        aria-label="Search"
      >
        <BiSearch className="text-white text-3xl text-center w-full" />
      </button>
    </form>
  );
}
